import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'product-type',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'product-type',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'product-type',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'product-type',
  action: ActionType.UPDATE,
};

export const ProductType = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
